/* eslint @typescript-eslint/ban-types: 0 */
import { ApolloClient, InMemoryCache } from '@apollo/client';
import { CombinedGraphQLErrors } from '@apollo/client/errors';
import { SetContextLink } from '@apollo/client/link/context';
import { ErrorLink } from '@apollo/client/link/error';
import { HttpLink } from '@apollo/client/link/http';

export const baseUrl =
    import.meta.env.VITE__API_URL ?? 'https://mushroom.avantmedia.uk'; // NOSONAR - production fallback

const httpLink = new HttpLink({
    uri: `${baseUrl}/graphql`,
});

const authLink = new SetContextLink((prevContext, operation) => {
    const token = localStorage.getItem('token');
    return {
        headers: {
            ...prevContext.headers,
            authorization: token ? `Bearer ${token}` : '',
        },
    };
});

const errorLink = new ErrorLink(({ error, operation }) => {
    // Check for GraphQL errors
    if (CombinedGraphQLErrors.is(error)) {
        for (const graphQLError of error.errors) {
            if (
                localStorage.getItem('token') &&
                graphQLError.message === 'Unauthorized'
            ) {
                // Clear the token and refresh the page
                localStorage.removeItem('token');
                window.location.reload();
                return;
            }
        }
    }

    // Check for network errors with 401 status via operation context
    const statusCode = operation.getContext().response?.status;
    if (localStorage.getItem('token') && statusCode === 401) {
        // Clear the token and refresh the page
        localStorage.removeItem('token');
        window.location.reload();
    }
});

export const client = new ApolloClient({
    link: errorLink.concat(authLink.concat(httpLink)),
    cache: new InMemoryCache(),
    defaultOptions: {
        query: {
            fetchPolicy: 'cache-first',
        },
        watchQuery: {
            fetchPolicy: 'cache-and-network',
            notifyOnNetworkStatusChange: false,
        },
    },
});

export const apiRawFetch = async (path: string, method = 'get', body?: {}) => {
    const token = localStorage.getItem('token');
    const headers: Record<string, string> = {
        'Content-Type': 'application/json',
    };

    if (token) {
        headers.Authorization = `Bearer ${token}`;
    }

    const response = await fetch(`${baseUrl}/${path}`, {
        method,
        headers,
        ...(method.toLowerCase() !== 'get' && { body: JSON.stringify(body) }),
    });

    if (response.status === 401 && localStorage.getItem('token')) {
        // Clear the token and refresh the page
        localStorage.removeItem('token');
        window.location.reload();
    }

    return response;
};
